const [ w, d, l ] = [ window, document, location ]

const init = () => {

  $.when( w.load['header'] ).then( () => {
    $('.p-gnav__list').currentMenu({mode: 0, url: l.pathname+l.search });
  });

}

export default function INFO () {
  $( init )
}